import type React from "react";
import {Button, InputAdornment, Stack, TextField} from "@mui/material";
import SearchIcon from '~/icons/svg/SearchIcon.svg?react'
import type {RiskSignalImpactType} from "~/pages/supplier-360/types/Supplier360Types";
import {
    categoryOptions,
    IMPACT_TYPE_OPTIONS,
    LANGUAGE_OPTIONS,
    type SignalFeedFilterState,
} from "~/pages/supplier-360/tabs/SupplierInsights/signalFeed";
import {COLORS} from "~/style/colors-ts";
import {SUPPLIER_DETAIL_STICKY_TOP} from "~/pages/supplier-360/constants/supplierDetailScroll";
import {MultiSelectFilter} from "~/components/multi-select-filter/MultiSelectFilter";

export const SignalFeedFilters: React.FC<{
    filters: SignalFeedFilterState;
    /** The search box's live text — the query only sees it once debounced. */
    searchInput: string;
    onFiltersChange: (next: Partial<SignalFeedFilterState>) => void;
    onSearchInput: (value: string) => void;
    onReset: () => void;
}> = ({filters, searchInput, onFiltersChange, onSearchInput, onReset}) => (
    <Stack
        direction="row"
        alignItems="center"
        gap={1.5}
        flexWrap="wrap"
        // Sticks under the detail page's tab bar while the feed scrolls; padding, not margin,
        // so cards scroll under an opaque strip instead of showing through a gap.
        sx={{
            position: 'sticky',
            top: SUPPLIER_DETAIL_STICKY_TOP,
            zIndex: 999,
            backgroundColor: COLORS.white[900],
            pt: 0.5,
            pb: 2,
        }}
    >
        <MultiSelectFilter
            label="Impact type"
            options={IMPACT_TYPE_OPTIONS}
            value={filters.impactTypes}
            // A new impact type invalidates the category pick, so it starts over
            onChange={v => onFiltersChange({impactTypes: v as RiskSignalImpactType[], categories: []})}
        />
        <MultiSelectFilter
            label="Event category"
            options={categoryOptions(filters.impactTypes)}
            value={filters.categories}
            onChange={v => onFiltersChange({categories: v})}
            width={240}
        />
        <MultiSelectFilter
            label="Language"
            options={LANGUAGE_OPTIONS}
            value={filters.languages}
            onChange={v => onFiltersChange({languages: v})}
            width={170}
        />
        <TextField
            size="small"
            placeholder="Search headlines…"
            value={searchInput}
            onChange={e => onSearchInput(e.target.value)}
            sx={{width: 240}}
            slotProps={{
                input: {
                    startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>,
                },
            }}
        />
        <Button size="small" color="inherit" onClick={onReset}>Reset</Button>
    </Stack>
);
